<mat-form-field style="width: 100%">
    <input matInput type="text" #googleAddress [placeholder]="placeHolder" (input)="getPlaceAutocomplete()" />
</mat-form-field>